module.exports = __webpack_public_path__ + "img/logo.e5a8e421.png";